import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "uk-flex uk-flex-center uk-flex-row uk-flex-wrap" }
const _hoisted_2 = { class: "uk-width-1-3 uk-text-left uk-flex uk-flex-column" }
const _hoisted_3 = { class: "uk-width-1-3 uk-text-left" }
const _hoisted_4 = { class: "uk-width-1-3 uk-text-left" }
const _hoisted_5 = { class: "uk-width-1-1 uk-margin uk-text-left" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "uk-width-1-1 uk-margin uk-text-left" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "uk-width-1-1 uk-flex-inline uk-flex-column uk-text-left" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "uk-form-danger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilterableDropdown = _resolveComponent("FilterableDropdown")!
  const _component_AddressInputBlock = _resolveComponent("AddressInputBlock")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("form", {
        onSubmit: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"])),
        class: "uk-margin uk-form uk-grid",
        "uk-grid": ""
      }, [
        _createElementVNode("div", _hoisted_2, [
          _cache[9] || (_cache[9] = _createElementVNode("label", {
            for: "loadNumber",
            class: "uk-form-label"
          }, "Load/Doc Number", -1)),
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loadNumber) = $event)),
            type: "text",
            id: "loadNumber",
            class: _normalizeClass(["uk-input uk-form-width-medium uk-width-1-1", { 'uk-form-danger': _ctx.textDanger }])
          }, null, 2), [
            [_vModelText, _ctx.loadNumber]
          ])
        ]),
        _createElementVNode("div", _hoisted_3, [
          _cache[10] || (_cache[10] = _createElementVNode("label", {
            for: "driver",
            class: "uk-form-label"
          }, "Driver", -1)),
          _createVNode(_component_FilterableDropdown, {
            modelValue: _ctx.driverId,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.driverId) = $event)),
            onInput: _ctx.driverInputChanged,
            options: _ctx.driversSelectFmtd,
            label: "nameWithPhone",
            reduce: driver => driver.id,
            class: "filter-width-medium",
            taggable: ""
          }, {
            "no-options": _withCtx(() => [
              _createElementVNode("button", {
                class: "uk-button uk-button-default",
                type: "button",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.showCreateDriverModal && _ctx.showCreateDriverModal(...args)))
              }, "Add new driver")
            ]),
            _: 1
          }, 8, ["modelValue", "onInput", "options", "reduce"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _cache[11] || (_cache[11] = _createElementVNode("label", {
            for: "customer",
            class: "uk-form-label"
          }, "Customer", -1)),
          _createVNode(_component_FilterableDropdown, {
            modelValue: _ctx.customerId,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.customerId) = $event)),
            onInput: _ctx.customerInputChanged,
            class: "filter-width-medium",
            options: _ctx.customersSelectFmtd,
            label: "nameWithEmail",
            reduce: customer => customer.id
          }, {
            "no-options": _withCtx(() => [
              _createElementVNode("button", {
                class: "uk-button uk-button-default",
                type: "button",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.showCreateCustomerModal && _ctx.showCreateCustomerModal(...args)))
              }, "Add new customer")
            ]),
            _: 1
          }, 8, ["modelValue", "onInput", "options", "reduce"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("a", {
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showOriginAddress = !_ctx.showOriginAddress)),
            class: "uk-link-toggle"
          }, [
            (_ctx.showOriginAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, "- Hide origin address"))
              : (_openBlock(), _createElementBlock("div", _hoisted_7, "+ Add origin address (optional)"))
          ])
        ]),
        (_ctx.showOriginAddress)
          ? (_openBlock(), _createBlock(_component_AddressInputBlock, {
              key: 0,
              class: "uk-margin-remove",
              label: 'Origin Address',
              address: _ctx.origAddress
            }, null, 8, ["address"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("a", {
            onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showDestAddress = !_ctx.showDestAddress)),
            class: "uk-link-toggle"
          }, [
            (_ctx.showDestAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, "- Hide destination address"))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, "+ Add destination address (optional)"))
          ])
        ]),
        (_ctx.showDestAddress)
          ? (_openBlock(), _createBlock(_component_AddressInputBlock, {
              key: 1,
              class: "uk-margin-remove",
              label: 'Destination Address',
              address: _ctx.destAddress
            }, null, 8, ["address"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_11, [
          _cache[13] || (_cache[13] = _createElementVNode("label", { class: "uk-form-label" }, _toDisplayString('\xa0'), -1)),
          _createElementVNode("button", {
            class: "uk-button uk-button-primary uk-form-controls",
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.addNewLoad && _ctx.addNewLoad(...args)))
          }, [...(_cache[12] || (_cache[12] = [
            _createElementVNode("div", { "uk-icon": "icon: plus" }, null, -1),
            _createTextVNode("Create Load ", -1)
          ]))])
        ])
      ], 32)
    ]),
    (_ctx.loadingLoad)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[14] || (_cache[14] = [
          _createElementVNode("div", {
            class: "uk-alert-primary",
            "uk-alert": ""
          }, [
            _createElementVNode("div", { "uk-spinner": "" })
          ], -1)
        ]))]))
      : _createCommentVNode("", true),
    (_ctx.loadFormError)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          _createElementVNode("p", null, _toDisplayString(_ctx.loadFormError), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}